import { create } from "zustand";
import type {
  MetadataVO,
  JobMetadata,
  JobRankMetadata,
  SelectMetadataVO,
  AppointmentLocationConfig,
  FormRequiredConfig,
  PolicySyncFieldConfig,
} from "../api/types/common.js";
import { getMetadata } from "../api/common";

interface MetadataState {
  metadata: MetadataVO | null;
  loading: boolean;
  loaded: boolean;
  fetchMetadata: () => Promise<void>;

  // 便捷访问属性
  craVersion: string | undefined;
  fnaVersion: string | undefined;
  jobMetadataList: JobMetadata[];
  formRequiredConfig: FormRequiredConfig[];
  jobRankMetadataList: JobRankMetadata[];
  selectMetadataList: SelectMetadataVO[];
  appointmentLocation: AppointmentLocationConfig[];
  policySyncFieldConfig: PolicySyncFieldConfig[];
  policyAttachmentConfig: any[];
  tenantName?: string;
}

export const useMetadataStore = create<MetadataState>((set, get) => ({
  metadata: null,
  loading: false,
  loaded: false,

  craVersion: undefined,
  fnaVersion: undefined,
  jobMetadataList: [],
  jobRankMetadataList: [],
  formRequiredConfig: [],
  selectMetadataList: [],
  appointmentLocation: [],
  policySyncFieldConfig: [],
  policyAttachmentConfig: [],
  tenantName: "",

  fetchMetadata: async () => {
    const { loaded, loading } = get();

    // 如果已加载或正在加载，则不重复请求
    if (loaded || loading) return;

    set({ loading: true });
    try {
      const metadata = await getMetadata();
      set({
        metadata,
        loaded: true,
        craVersion: metadata.craVersion,
        fnaVersion: metadata.fnaVersion,
        formRequiredConfig: metadata.formRequiredConfig || [],
        jobMetadataList: metadata.jobMetadataList || [],
        jobRankMetadataList: metadata.jobRankMetadataList || [],
        selectMetadataList: metadata.selectMetadataList || [],
        appointmentLocation: metadata.appointmentLocation || [],
        policySyncFieldConfig: metadata.policySyncFieldConfig || [],
        policyAttachmentConfig: metadata.policyAttachmentConfig || [],
        tenantName: metadata.tenantName || "",
      });
    } catch (error) {
      console.error("加載元數據失敗:", error);
    } finally {
      set({ loading: false });
    }
  },
}));
